import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import useFetch from "../../../hook/useFetch";
import SuperUserLayout from "../SuperUserLayout";

const asEntries = (values) => Object.entries(values || {});

export default function ProductValidityDocumentation() {
  const { get } = useFetch();
  const [documentation, setDocumentation] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    get(
      "/admin/product_validity_documentation",
      null,
      (message) => setError(typeof message === "string" ? message : "Die Dokumentation konnte nicht geladen werden."),
      setDocumentation,
      () => setError("Die Dokumentation konnte nicht geladen werden.")
    );
  }, []); // The endpoint is loaded once when the protected page opens.

  return (
    <SuperUserLayout>
      <section className="rso-pages card shadow bg-white rounded p-4 m-0">
        <h1>Produktgültigkeit</h1>
        <p className="text-muted">
          Superuser-Dokumentation für Produktlaufzeiten, Lizenzen, Tokens und Capabilities.
        </p>

        {error && <div className="alert alert-danger">{error}</div>}
        {!documentation && !error && <Skeleton count={12} />}

        {documentation && <>
          <h2 className="h4 mt-4">Felder</h2>
          <div className="table-responsive">
            <table className="table">
              <thead><tr><th>Feld</th><th>Typ</th><th>Erlaubte Werte</th><th>Standard</th></tr></thead>
              <tbody>
                {asEntries(documentation.fields).map(([name, field]) => (
                  <tr key={name}>
                    <td><code>{name}</code></td>
                    <td>{field.type}</td>
                    <td>{asEntries(field.allowed_values).map(([value, label]) => `${value}=${label}`).join(", ") || `≥ ${field.minimum}`}</td>
                    <td>{field.default}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h2 className="h4 mt-4">Kombinationen</h2>
          <div className="table-responsive">
            <table className="table">
              <thead><tr><th>Modus</th><th>Wert</th><th>Einheiten</th><th>Bestellende</th></tr></thead>
              <tbody>
                {(documentation.combinations || []).map((combination) => (
                  <tr key={combination.validity_mode}>
                    <td>{combination.validity_mode} = {combination.name}</td>
                    <td>{combination.validity_value}</td>
                    <td>{(combination.validity_unit || []).map((unit) => `${unit.validity_unit}=${unit.name}`).join(", ")}</td>
                    <td>{combination.order_end || combination.note || "Kein Ablaufdatum"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h2 className="h4 mt-4">API-Methoden</h2>
          <ul>{asEntries(documentation.methods).map(([method, description]) => <li key={method}><code>{method}</code>: {description}</li>)}</ul>

          <h2 className="h4 mt-4">Aktuelles Bestellverhalten</h2>
          <ul>{asEntries(documentation.current_order_behavior).map(([name, value]) => <li key={name}><strong>{name}:</strong> {value}</li>)}</ul>
        </>}
      </section>
    </SuperUserLayout>
  );
}
